import React from "react";

const VideosTriangle = ({
  backgroundColor = "none",
  className = "",
  color = "#ffffff",
  height = 21,
  style = {},
  viewBox = "-2 0 21 17",
  width = 21
}) => (
  <svg
    height={height}
    width={width}
    className={className}
    style={style}
    viewBox={viewBox}
  >
    <path
      fill={backgroundColor}
      fillRule="evenodd"
      stroke={color}
      strokeWidth="3"
      d="M14.53 9L1.5 2.485v13.03L14.53 9zm.55-.275h0z"
    />
  </svg>
);

export default VideosTriangle;
